/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const userSuggestionSchema = z.object({
  accountId: z.string(),
  avatarUrl: z.string(),
  displayName: z.string(),
});
